import { render, staticRenderFns } from "./image-tab.vue?vue&type=template&id=167c3f74&scoped=true"
import script from "./image-tab.vue?vue&type=script&lang=js"
export * from "./image-tab.vue?vue&type=script&lang=js"
import style0 from "./image-tab.vue?vue&type=style&index=0&id=167c3f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167c3f74",
  null
  
)

export default component.exports